/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} HttpsyoursitecomInputs */

const en_httpsyoursitecom = /** @type {(inputs: HttpsyoursitecomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://yoursite.com`)
};

const es_httpsyoursitecom = /** @type {(inputs: HttpsyoursitecomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://tusitio.com`)
};

const fr_httpsyoursitecom = /** @type {(inputs: HttpsyoursitecomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://votresite.com`)
};

const de_httpsyoursitecom = /** @type {(inputs: HttpsyoursitecomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://deineseite.com`)
};

const ja_httpsyoursitecom = /** @type {(inputs: HttpsyoursitecomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://yoursite.com`)
};

const zh_httpsyoursitecom = /** @type {(inputs: HttpsyoursitecomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://yoursite.com`)
};

const ar_httpsyoursitecom = /** @type {(inputs: HttpsyoursitecomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://yoursite.com`)
};

const id_httpsyoursitecom = /** @type {(inputs: HttpsyoursitecomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://situsanda.com`)
};

const it_httpsyoursitecom = /** @type {(inputs: HttpsyoursitecomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://iltuosito.com`)
};

const ru_httpsyoursitecom = /** @type {(inputs: HttpsyoursitecomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://yoursite.com`)
};

const pt_httpsyoursitecom = /** @type {(inputs: HttpsyoursitecomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://seusite.com`)
};

const ko_httpsyoursitecom = /** @type {(inputs: HttpsyoursitecomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://yoursite.com`)
};

/**
* | output |
* | --- |
* | "https://yoursite.com" |
*
* @param {HttpsyoursitecomInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const httpsyoursitecom = /** @type {((inputs?: HttpsyoursitecomInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<HttpsyoursitecomInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_httpsyoursitecom(inputs)
	if (locale === "es") return es_httpsyoursitecom(inputs)
	if (locale === "fr") return fr_httpsyoursitecom(inputs)
	if (locale === "de") return de_httpsyoursitecom(inputs)
	if (locale === "ja") return ja_httpsyoursitecom(inputs)
	if (locale === "zh") return zh_httpsyoursitecom(inputs)
	if (locale === "ar") return ar_httpsyoursitecom(inputs)
	if (locale === "id") return id_httpsyoursitecom(inputs)
	if (locale === "it") return it_httpsyoursitecom(inputs)
	if (locale === "ru") return ru_httpsyoursitecom(inputs)
	if (locale === "pt") return pt_httpsyoursitecom(inputs)
	return ko_httpsyoursitecom(inputs)
});